<pre>{{ content | async }}</pre>